import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  container: {
    width: '80%',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      width: '85%',
    },
  },
  itemTitle: {
    marginBottom: '20px',
  },
  text: {
    marginBottom: '20px',
  },
  listWrapper: {
    marginTop: '0',
  },
  list: {
    '&::marker': {
      color: theme.palette.garamMasala.main,
    },
  },
});
